export default "__VITE_ASSET__Dfpvp2Xp__"